"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @private
 */
exports.USER_COMPANY_ENDPOINT = {
    putCancelUserAccount: '/user-company/{{version}}/users/{{userUuid}}/cancel-account',
};
